import React, { useEffect } from 'react';

const Logout = () => {
    useEffect(() => {
        document.title = "Çıkış Yapıldı | LEVELUP CRM";

        localStorage.removeItem('token');
    }, []);
    
    return (
        <main class="auth-cover-wrapper">
            <div class="auth-cover-content-inner">
                <div class="auth-cover-content-wrapper">
                    <div class="auth-img">
                        <img src="assets/images/auth/auth-cover-login-bg.svg" alt="" class="img-fluid" />
                    </div>
                </div>
            </div>
            <div class="auth-cover-sidebar-inner">
                <div class="auth-cover-card-wrapper">
                    <div class="auth-cover-card p-sm-5">
                        <div class="wd-50 mb-5">
                            <img src="assets/images/crm-logo-small.png" class="img-fluid" />
                        </div>
                        <h2 class="fs-20 fw-bolder mb-4">Çıkış Yap</h2>
                        <h4 class="fs-13 fw-bold mb-2">Hesabınızdan başarıyla çıkış yapıldı!</h4>
                        <p class="fs-13 mb-3">Tekrar giriş yapmak için lütfen aşağıdaki butona tıklayınız.</p>
                        <a href="/login" class="btn btn-lg btn-primary w-100">Giriş Yap</a>
                        <div class="w-100 mt-5 text-center mx-auto">
                            <div class="d-flex align-items-center justify-content-center gap-2">
                                <a href="https://levelupcrm.com.tr" target="_blank" class="btn btn-light-brand flex-fill" data-bs-toggle="tooltip" data-bs-trigger="hover" title="Levelup CRM Web Sitesi">
                                    <i class="feather-globe me-2"></i>
                                    Levelup CRM
                                </a>
                                <a href="https://levelupagency.com.tr" target="_blank" class="btn btn-light-brand flex-fill" data-bs-toggle="tooltip" data-bs-trigger="hover" title="Levelup Agency Web Sitesi">
                                    <i class="feather-globe me-2"></i>
                                    Levelup Agency
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Logout;
